import { styled } from '@clickcease/cc-client-components-lib'

export const VerticalScrollModifier = styled('div', {
  position: 'relative',
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
})
